import {accordion} from "../../sources/js/functions/accordion";

accordion('.questions__question', '.questions__answer');
